import { render, staticRenderFns } from "./AssumptionReportLegendCardUpdated.vue?vue&type=template&id=a4790c02&scoped=true&"
import script from "./AssumptionReportLegendCardUpdated.vue?vue&type=script&lang=ts&"
export * from "./AssumptionReportLegendCardUpdated.vue?vue&type=script&lang=ts&"
import style0 from "./AssumptionReportLegendCardUpdated.vue?vue&type=style&index=0&id=a4790c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4790c02",
  null
  
)

export default component.exports